import ClientConfig from "shared/config";

// Generates the URL for Pile API requests.
export function getPileURL(
  tenant: string,
  usergroup: string,
  user: string,
  suffix = ""
): string {
  return new URL(
    `${tenant}/${usergroup}/${user}/projects/${suffix}`,
    ClientConfig.pileURL
  ).toString();
}
